export default "__VITE_ASSET__BB4ClfZX__"